import React, { useState } from 'react';
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import * as actions from '../../store/actions/index';
import classes from './Networks.css';

const NETWORK_TYPE_LABELS = {
  ADMIN: 'ADMIN NETWORK',
  GUEST: 'GUEST NETWORK',
  STAFF: 'STAFF NETWORK',
  OFFICE: 'OFFICE NETWORK',
  IOT: 'IOT NETWORK',
};

const Networks = (props) => {
  const [upArrow, setUpArrow] = useState(true);

  const arrow = upArrow
    ? <MdKeyboardArrowUp color={'gray'} size={'30px'} />
    : <MdKeyboardArrowDown color={'gray'} size={'30px'} />;

  const networksData = props.networks || {};
  const networks = Object.keys(networksData)
    .filter(key => !isNaN(key))
    .map(key => networksData[key])
    .filter(network => network.wifiType !== 'HOME');

  const handleNetworkClick = (network) => {
    if (props.selectedNetwork && props.selectedNetwork.wifiType === network.wifiType) return;
    props.setSelectedNetwork(network);
    if (window.innerWidth <= 600) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const renderNetworkItem = (network) => {
    const isSelected = props.selectedNetwork && props.selectedNetwork.wifiType === network.wifiType;
    const devices = isSelected && props.networkDevices ? props.networkDevices : [];
    const connectedCount = devices.filter((d) => {
      const state = d.connectionState && d.connectionState.toUpperCase();
      return state === 'ACTIVE' || state === 'CONNECTED';
    }).length;
    return (
      <div
        key={network.wifiType}
        className={[classes.NetworkItem, isSelected ? classes.SelectedNetwork : ''].join(' ')}
        onClick={() => handleNetworkClick(network)}
      >
        <div className={classes.NetworkTypeLabel}>
          {NETWORK_TYPE_LABELS[network.wifiType] || network.wifiType}
        </div>
        <div className={classes.NetworkName}>{network.wifiSsidName}</div>
        {isSelected && devices.length > 0 && network.wifiType !== 'GUEST' && (
          <div className={classes.DeviceCount}>Devices: {connectedCount}/{devices.length}</div>
        )}
      </div>
    );
  };

  return (
    <div className={classes.NetworksContainer}>
      {/* Desktop: collapsible */}
      <div className={classes.ShowDesktop}>
        <Collapsible
          transitionTime={100}
          open={upArrow}
          onOpening={() => setUpArrow(true)}
          onClosing={() => setUpArrow(false)}
          trigger={
            <div className={classes.TriggerRow}>
              <b>Networks</b>
              <button className={classes.OpenCloseButton} aria-label="toggle networks">
                {arrow}
              </button>
            </div>
          }
        >
          <div>
            {networks.map((network) => renderNetworkItem(network))}
          </div>
        </Collapsible>
      </div>

      {/* Mobile: inline list matching IOT Network Details style */}
      <div className={classes.ShowMobile}>
        <div className={classes.MobileSectionTitle}>
          <b>Networks</b>
        </div>
        <div>
          {networks.map((network) => renderNetworkItem(network))}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  networks: state.propertyIOTNetwork.networks,
  selectedNetwork: state.propertyIOTNetwork.selectedNetwork,
  networksLoading: state.propertyIOTNetwork.networksLoading,
  networkDevices: state.propertyIOTNetwork.networkDevices,
});

const mapDispatchToProps = (dispatch) => ({
  setSelectedNetwork: (network) => dispatch(actions.setSelectedNetwork(network)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Networks);
